import { render, staticRenderFns } from "./ContactQuarantineTable.vue?vue&type=template&id=799921c7&scoped=true"
import script from "./ContactQuarantineTable.vue?vue&type=script&lang=js"
export * from "./ContactQuarantineTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "799921c7",
  null
  
)

export default component.exports